import * as types from '../mutation-types'
import { tempTransactionStatus } from '@/helpers/enums'

export default {
	namespaced: true,
	state: {
		transactions: [],
		transactionsJournal: [],
		tempTransactions: [],
		statementTransactions: []
	},

	actions: {
		fetchAll({ commit }) {
			return window.axios.get('/materialTransactions/selfTransactionsSummary')
				.then((response) => {
					commit(types.STORE_TRANSACTIONS_SUMMARY, response.data);
					return response.data;
				});
		},

		fetchJournal({ commit }) {
			return window.axios.get('/MaterialTransactions/TransactionsJournal')
				.then((response) => {
					commit(types.STORE_TRANSACTIONS_JOURNAL, response.data);
					return response.data;
				});
		},

		/*
			كشف يومية المواد - الحركات الفردية (غير مجمّعة) ليوم واحد، وتُجمّع لاحقاً في الصفحة
			حسب المادة ثم حسب الزبون. الغلاف يعيد totalInAmount/totalOutAmount لكنهما مجموع
			كميات لا مبالغ، لذلك لا نخزّنهما - الإجمالي المالي يُحسب من totalSales
		*/
		fetchStatement({ commit }, { materialId, fromDate, toDate, accountId, entityId, entityTypeId, type, returnedTransactions, withVisitTransaction, isInput, sortByCreatedAt, regionIds, getAll, page, perPage } = {}) {
			return window.axios.get('/MaterialTransactions/StatementWithEntityType', {
				params: {
					MaterialId: materialId,
					FromDate: fromDate,
					ToDate: toDate,
					AccountId: accountId,
					EntityId: entityId,
					EntityTypeId: entityTypeId,
					Type: type,
					ReturnedTransactions: returnedTransactions,
					WithVisitTransaction: withVisitTransaction,
					IsInput: isInput,
					SortByCreatedAt: sortByCreatedAt,
					RegionIds: regionIds,
					GetAll: getAll,
					Page: page,
					PerPage: perPage
				},
				// RegionIds مصرّح عنه collectionFormat: multi، وصيغة axios الافتراضية `ids[]=` لا يربطها الـ API
				paramsSerializer: { indexes: null }
			})
				.then(({ data }) => {
					commit(types.STORE_TRANSACTIONS_STATEMENT, data?.transactions);
					return data;
				});
		},

		fetchTempTransactions({ commit, rootState }) {
			return window.axios.get('/materialTransactions/tempTransaction', {
				params: {
					ToAccountIds: [rootState.auth.userData.accountId],
					TempTransactionStatus: [tempTransactionStatus.pending]
				},
				// the endpoint expects repeated keys (collectionFormat: multi); axios' default
				// `ids[]=` form is not bound by the API and the status filter is silently ignored,
				// which let already-accepted temp transactions leak into the pending list
				paramsSerializer: { indexes: null }
			})
				.then((response) => {
					commit(types.STORE_TEMP_TRANSACTIONS, response.data);
					return response.data;
				});
		},

		acceptTempTransaction({ dispatch }, { id }) {
			return window.axios.post(`/materialTransactions/tempTransaction/${id}/Accept`)
				.then((response) => {
					// accepting adds stock to the material, so the remaining amounts
					// shown from the transactions summary must be refreshed too
					return Promise.all([
						dispatch('fetchTempTransactions'),
						dispatch('fetchAll')
					]).then(() => response.data);
				});
		},

		reset({ commit }) {
			commit(types.RESET_TRANSACTIONS_SUMMARY);
		},

		resetJournal({ commit }) {
			commit(types.RESET_TRANSACTIONS_JOURNAL);
		},

		resetTempTransactions({ commit }) {
			commit(types.RESET_TEMP_TRANSACTIONS);
		},

		resetStatement({ commit }) {
			commit(types.RESET_TRANSACTIONS_STATEMENT);
		}
	},

	mutations: {
		[types.STORE_TRANSACTIONS_SUMMARY](state, transactions) {
			state.transactions = transactions.sort(function(a, b) {
				if (a.name < b.name) {
					return -1
				};
				if (a.name > b.name) {
					return 1
				};
				return 0
			});
		},

		[types.STORE_TRANSACTIONS_JOURNAL](state, transactionsJournal) {
			state.transactionsJournal = Array.isArray(transactionsJournal) ? transactionsJournal : [];
		},

		[types.STORE_TEMP_TRANSACTIONS](state, tempTransactions) {
			state.tempTransactions = Array.isArray(tempTransactions) ? tempTransactions : [];
		},

		[types.STORE_TRANSACTIONS_STATEMENT](state, statementTransactions) {
			state.statementTransactions = Array.isArray(statementTransactions) ? statementTransactions : [];
		},

		[types.RESET_TRANSACTIONS_SUMMARY](state) {
			state.transactions = [];
		},

		[types.RESET_TRANSACTIONS_JOURNAL](state) {
			state.transactionsJournal = [];
		},

		[types.RESET_TEMP_TRANSACTIONS](state) {
			state.tempTransactions = [];
		},

		[types.RESET_TRANSACTIONS_STATEMENT](state) {
			state.statementTransactions = [];
		},
	},

	getters: {
		getTransactionById: state => id => state.transactions.find(c => c.id === id),
		getJournalTransactionById: state => id => state.transactionsJournal.find(c => c.id === id),

		getMaterialRemainingAmount: state => materialId => {
			const transaction = state.transactions.find(c => c.materialId === materialId);
			const amount = transaction?.remaining?.amount - transaction?.remainingDamaged?.amount;
			return typeof amount === 'number' && amount >= 0 ? amount : 0;
		},

		/*
			مجموع الكميات التي تطالب بها كل العناصر الموجودة حالياً في طابور المزامنة (idb.objects.syncQueue
			عبر sync.js) - سواء pending أو error، فالعنصر الفاشل لم يُزامَن بعد ويبقى شاغلاً لحصته حتى
			يحذفه المندوب يدوياً من SyncQueueDialog
		*/
		getPendingClaimedAmount: (state, getters, rootState) => materialId =>
			rootState.sync.queue.reduce((sum, item) => {
				const claimed = (item.visitPayload.materialAmounts || []).find(m => m.materialId === materialId);
				return sum + (claimed ? claimed.amount : 0);
			}, 0),

		getAdjustedRemainingAmount: (state, getters) => materialId =>
			getters.getMaterialRemainingAmount(materialId) - getters.getPendingClaimedAmount(materialId)
	}
}
